import { useRouter } from 'next/router'
import { signIn } from 'next-auth/client'

// Components.
import DevLogin from 'components/Login/DevLogin'
import SocialLogin from 'components/Login/SocialLogin'
import BackButton from 'components/Login/BackButton'

// Styles.
import styles from './Login.module.scss'

export default function Login({ providers, token }) {
  const router = useRouter()

  return (
    <section className={styles.section}>
      {Object.values(providers).map((provider) =>
        provider.id === 'dev-login' ? (
          <DevLogin key={provider.id} token={token} />
        ) : (
          <SocialLogin
            key={provider.id}
            provider={provider}
            callback={() =>
              signIn(provider.id, { callbackUrl: router.query.callbackUrl })
            }
          />
        ),
      )}
      <BackButton />
    </section>
  )
}
